interface MailtoParts {
  recipient: string;
  subject: string;
  body: string;
}

/**
 * Builds a `mailto:` URL that hands recipient, subject, and body to the OS mail client.
 * Line breaks must be %0D%0A per RFC 6068 — mail clients collapse plain \n bodies to a single
 * line — so breaks are normalized to \r\n before percent-encoding. Encoding uses
 * encodeURIComponent, not URLSearchParams, which encodes spaces as "+" and mail clients render
 * those literally. Empty parts are omitted rather than sent as empty header lines, and staff may
 * leave both empty and compose in the mail client. Very long bodies may be truncated by the mail
 * client (Windows caps the URL at ~2000 characters) — accepted limitation of the mailto mechanism.
 */
export function buildMailtoUrl({ recipient, subject, body }: MailtoParts): string {
  const params: string[] = [];
  if (subject) {
    params.push(`subject=${encodeURIComponent(subject)}`);
  }
  if (body) {
    params.push(`body=${encodeURIComponent(body.replace(/\r\n|\r|\n/g, "\r\n"))}`);
  }

  const query = params.length > 0 ? `?${params.join("&")}` : "";

  return `mailto:${encodeURIComponent(recipient)}${query}`;
}
